import { render, staticRenderFns } from "./teacherDetails.vue?vue&type=template&id=ea3eafec"
import script from "./teacherDetails.vue?vue&type=script&lang=js"
export * from "./teacherDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea3eafec')) {
      api.createRecord('ea3eafec', component.options)
    } else {
      api.reload('ea3eafec', component.options)
    }
    module.hot.accept("./teacherDetails.vue?vue&type=template&id=ea3eafec", function () {
      api.rerender('ea3eafec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prepareLesson/teacherDetails.vue"
export default component.exports